import { billedUserWarning } from './billedUserWarning';

export const BilledUserInlineMessage = () => {
    return <p>{billedUserWarning}</p>;
};
